module.exports = __webpack_public_path__ + "assets/priceoff1.jpg?6c72ee05156c694f73407b6b58d7e53d";